module.exports = __webpack_public_path__ + "img/sem-multa-2.cad53b11.svg";